export const preferences = {
  mode: "Tema",
  text: "Texto",
  translationFeature: "Traducción",
  emailUpdates: "Actualizaciones por correo",
  daily: "Diaria",
  weekly: "Semanal",
  monthly: "Mensual",
};
